import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface FormFieldBoxProps {
  children: JSX.Element;
  optionalStyles?: React.CSSProperties;
  fieldName: string;
  isRequired: boolean;
}

export function FormFieldBox({
  children,
  optionalStyles,
  fieldName,
  isRequired = true,
}: FormFieldBoxProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'stretch',
        alignItems: 'flex-start',
        flex: '1 0 0',
        ...optionalStyles,
      }}
    >
      <Typography variant='h6' mb={theme.spacing(0.75)}>
        {fieldName}
        {isRequired &&
        <span
          style={{
            color: theme.palette.brand.primary,
            marginLeft: theme.spacing(0.5),
          }}
        >
          *
        </span>}
      </Typography>
      {children}
    </Box>
  );
}
